import React, { useState } from "react";
import {
  Button,
  Box,
  Grid,
  Typography,
  Tab,
  Autocomplete,
  TextField,
  Menu,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { TabList, TabPanel, TabContext } from "@mui/lab";
import CommonBreadCrumb from "components/commonBreadCrumb/CommonBreadCrumb";
import CommonTable from "components/commonTable/CommonTable";
import Loader from "components/loader/Loader";
import CommonFilter from "components/commonFilter/CommonFilter";
import DateTab from "pages/date/Date";
import LocationDropdown from "components/LocationDropdown/LocationDropdown";

export default function ReportsTab(props) {
  const maxAllowedDays = process.env.MAX_REPORT_GEN_DURATION_DAYS || 548
  const handleChange = (event, newValue) => {
    props?.handleChange(newValue);
  };
  const handleLocationChange = (location) => {
    //console.log( 'Location changed ReportsTab:', location);
    props.onInputChange(location);
  };
  const handleChangePage = (event, newPage) => {
    props?.handleChangePage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    props?.handleChangeRowsPerPage(event);
  };

  const onClickTableVendor = (data) => {
    props?.onClickTableVendor(data);
  };

  const onExport = () => {
    props?.onExport();
  };

  const breadcrumbPaths = [
    { name: props?.title, url: "", className: "colorBlue" },
  ];

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelectFormat = (format) => {
    props?.onRequestReport(format);
    handleClose();
  };

  return (
    <Grid container>
      <CommonBreadCrumb paths={breadcrumbPaths} />

      <Grid item className="tableContainer marginTop15" xs={12}>
        <Box className="contentBoxStyle">
          <TabContext value={props?.value}>
          <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Grid item xs={12} sm={6} md={6}>
                <TabList
                  className="minHeight32"
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  variant="scrollable"
                  scrollButtons={false}
                  sx={{
                    minWidth: '100%',
                    '& .MuiTabs-flexContainer': {
                      gap: '8px',
                    },
                    '& .MuiTab-root': {
                      minWidth: 'auto',
                      padding: '6px 16px',
                    }
                  }}
                >
                  <Tab label="All" value="" className="tabStyle" />
                  <Tab label="Ride" value="1" className="tabStyle" />
                  <Tab label="Rental" value="3" className="tabStyle" />
                  <Tab label="Airport" value="4" className="tabStyle" />
                  <Tab label="OutStation" value="9" className="tabStyle" />
                </TabList>
              </Grid>

              <Grid
                item
                container
                md={6}
                sm={6}
                xs={12}
                spacing={2}
                sx={{
                  display: 'flex',
                  justifyContent: { xs: 'flex-start', sm: 'flex-end' },
                  alignItems: 'center',
                }}
              >
                <Grid item xs={12} sm={5} md={4}>
                  <LocationDropdown
                    onChange={handleLocationChange}
                    className="location-dropdown"
                  />
                </Grid>
                <Grid 
                  item 
                  sx={{ 
                    marginTop: { xs: '20px', sm: '0px' },
                    marginLeft: { xs: '0px', sm: '15px' }
                  }}
                >
                  <DateTab
                    onSelectDateRange={props?.onSelectDateRange}
                    tabName={props?.tabName}
                    dateFrom={props?.dateFrom}
                    dateTo={props?.dateTo}
                    maxAllowedDays={maxAllowedDays}
                    maxDate={new Date()}
                  />
                </Grid>
              </Grid>
            </Grid>

            <TabPanel value="" className="vendotTable">
              {props?.loader ? (
                <Loader />
              ) : (
                <>
                  <Grid
                    item
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    className="transictionHeader"
                  >
                    <Typography className="fontNormal font18 colorBlack">
                      {props?.title + " Reports"}
                    </Typography>

                    {props?.hasViewMoreIcon && (
                      <div style={{ display: "flex", gap: "20px" }}>
                        <Button
                          className="requestBtnStyle"
                          onClick={handleClick}
                          disabled={props.isRequestingReport}
                        >
                          {props.isRequestingReport ? (
                            <CircularProgress
                              size={20}
                              sx={{ color: "#fff" }}
                            />
                          ) : (
                            "Request Report"
                          )}
                        </Button>
                        <Menu
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          PaperProps={{
                            sx: { width: anchorEl ? anchorEl.offsetWidth : "auto" }, // match button width
                          }}
                        >
                          <MenuItem onClick={() => handleSelectFormat("csv")} sx={{ width: "100%",  fontSize: "14px" }}>
                            Excel/CSV
                          </MenuItem>
                          <MenuItem onClick={() => handleSelectFormat("pdf")}>
                            PDF
                          </MenuItem>
                        </Menu>
                        <Button
                          className="exportBtnStyle"
                          onClick={() => onExport()}
                        >
                          Send Report to mail
                        </Button>
                      </div>
                    )}
                  </Grid>
                  <CommonTable
                    data={props?.rideTrackData}
                    onClickTableVendor={onClickTableVendor}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={props?.page}
                    rowsPerPage={props?.rowsPerPage}
                    loader={props?.loader}
                    isClickable={props?.isClickable}
                  />
                </>
              )}
            </TabPanel>

            <TabPanel value="1" className="vendotTable">
              {props?.loader ? (
                <Loader />
              ) : (
                <>
                  <Grid
                    item
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    className="transictionHeader"
                  >
                    <Typography className="fontNormal font18 colorBlack">
                      {props?.title + " Reports"}
                    </Typography>

                    {props?.hasViewMoreIcon && (
                      <div style={{ display: "flex", gap: "20px" }}>
                        <Button
                          className="requestBtnStyle"
                          onClick={handleClick}
                          disabled={props.isRequestingReport}
                        >
                          {props.isRequestingReport ? (
                            <CircularProgress
                              size={20}
                              sx={{ color: "#fff" }}
                            />
                          ) : (
                            "Request Report"
                          )}
                        </Button>
                        <Menu
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          PaperProps={{
                            sx: { width: anchorEl ? anchorEl.offsetWidth : "auto" }, // match button width
                          }}
                        >
                          {/* <MenuItem onClick={() => handleSelectFormat("pdf")}>
                            PDF
                          </MenuItem> */}
                          <MenuItem onClick={() => handleSelectFormat("csv")} sx={{ width: "100%",  fontSize: "14px" }}>
                            Excel/CSV
                          </MenuItem>
                          <MenuItem onClick={() => handleSelectFormat("pdf")}>
                            PDF
                          </MenuItem>
                        </Menu>
                        <Button
                          className="exportBtnStyle"
                          onClick={() => onExport()}
                        >
                          Send Report to mail
                        </Button>
                      </div>
                    )}
                  </Grid>
                  <CommonTable
                    data={props?.rideTrackData}
                    onClickTableVendor={onClickTableVendor}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={props?.page}
                    rowsPerPage={props?.rowsPerPage}
                    loader={props?.loader}
                    isClickable={props?.isClickable}
                  />
                </>
              )}
            </TabPanel>

            <TabPanel value="3" className="vendotTable">
              

              {props?.loader ? (
                <Loader />
              ) : (
                <>
                  <Grid
                    item
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    className="transictionHeader"
                  >
                    <Typography className="fontNormal font18 colorBlack">
                      {props?.title + " Reports"}
                    </Typography>

                    {props?.hasViewMoreIcon && (
                      <div style={{ display: "flex", gap: "20px" }}>
                        <Button
                          className="requestBtnStyle"
                          onClick={handleClick}
                          disabled={props.isRequestingReport}
                        >
                          {props.isRequestingReport ? (
                            <CircularProgress
                              size={20}
                              sx={{ color: "#fff" }}
                            />
                          ) : (
                            "Request Report"
                          )}
                        </Button>
                        <Menu
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          PaperProps={{
                            sx: { width: anchorEl ? anchorEl.offsetWidth : "auto" }, // match button width
                          }}
                        >
                          {/* <MenuItem onClick={() => handleSelectFormat("pdf")}>
                            PDF
                          </MenuItem> */}
                          <MenuItem onClick={() => handleSelectFormat("csv")} sx={{ width: "100%",  fontSize: "14px" }}>
                            Excel/CSV
                          </MenuItem>
                          <MenuItem onClick={() => handleSelectFormat("pdf")}>
                            PDF
                          </MenuItem>
                        </Menu>
                        <Button
                          className="exportBtnStyle"
                          onClick={() => onExport()}
                        >
                          Send Report to mail
                        </Button>
                      </div>
                    )}
                  </Grid>

                  <CommonTable
                    data={props?.rideTrackData}
                    onClickTableVendor={onClickTableVendor}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={props?.page}
                    rowsPerPage={props?.rowsPerPage}
                    loader={props?.loader}
                    isClickable={props?.isClickable}
                  />
                </>
              )}
            </TabPanel>

            <TabPanel value="4" className="vendotTable">
              {props?.loader ? (
                <Loader />
              ) : (
                <>
                  <Grid
                    item
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    className="transictionHeader"
                  >
                    <Typography className="fontNormal font18 colorBlack">
                      {props?.title + " Airport Reports"}
                    </Typography>

                    {props?.hasViewMoreIcon && (
                      <div style={{ display: "flex", gap: "20px" }}>
                        <Button
                          className="requestBtnStyle"
                          onClick={handleClick}
                          disabled={props.isRequestingReport}
                        >
                          {props.isRequestingReport ? (
                            <CircularProgress
                              size={20}
                              sx={{ color: "#fff" }}
                            />
                          ) : (
                            "Request Report"
                          )}
                        </Button>
                        <Menu
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          PaperProps={{
                            sx: { width: anchorEl ? anchorEl.offsetWidth : "auto" }, // match button width
                          }}
                        >
                          {/* <MenuItem onClick={() => handleSelectFormat("pdf")}>
                            PDF
                          </MenuItem> */}
                          <MenuItem onClick={() => handleSelectFormat("csv")} sx={{ width: "100%",  fontSize: "14px" }}>
                            Excel/CSV
                          </MenuItem>
                          <MenuItem onClick={() => handleSelectFormat("pdf")}>
                            PDF
                          </MenuItem>
                        </Menu>
                        <Button
                          className="exportBtnStyle"
                          onClick={() => onExport()}
                        >
                          Send Report to mail
                        </Button>
                      </div>
                    )}
                  </Grid>

                  <CommonTable
                    data={props?.rideTrackData}
                    onClickTableVendor={onClickTableVendor}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={props?.page}
                    rowsPerPage={props?.rowsPerPage}
                    loader={props?.loader}
                    isClickable={props?.isClickable}
                  />
                </>
              )}
            </TabPanel>

            <TabPanel value="9" className="vendotTable">
            

              {props?.loader ? (
                <Loader />
              ) : (
                <>
                  <Grid
                    item
                    container
                    justifyContent="space-between"
                    alignItems="center"
                    className="transictionHeader"
                  >
                    <Typography className="fontNormal font18 colorBlack">
                      {props?.title + " OutStation Reports"}
                    </Typography>

                    {props?.hasViewMoreIcon && (
                      <div style={{ display: "flex", gap: "20px" }}>
                        <Button
                          className="requestBtnStyle"
                          onClick={handleClick}
                          disabled={props.isRequestingReport}
                        >
                          {props.isRequestingReport ? (
                            <CircularProgress
                              size={20}
                              sx={{ color: "#fff" }}
                            />
                          ) : (
                            "Request Report"
                          )}
                        </Button>
                        <Menu
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          PaperProps={{
                            sx: { width: anchorEl ? anchorEl.offsetWidth : "auto" }, // match button width
                          }}
                        >
                          {/* <MenuItem onClick={() => handleSelectFormat("pdf")}>
                            PDF
                          </MenuItem> */}
                          <MenuItem onClick={() => handleSelectFormat("csv")} sx={{ width: "100%",  fontSize: "14px" }}>
                            Excel/CSV
                          </MenuItem>
                          <MenuItem onClick={() => handleSelectFormat("pdf")}>
                            PDF
                          </MenuItem>
                        </Menu>
                        <Button
                          className="exportBtnStyle"
                          onClick={() => onExport()}
                        >
                          Send Report to mail
                        </Button>
                      </div>
                    )}
                  </Grid>

                  <CommonTable
                    data={props?.rideTrackData}
                    onClickTableVendor={onClickTableVendor}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={props?.page}
                    rowsPerPage={props?.rowsPerPage}
                    loader={props?.loader}
                    isClickable={props?.isClickable}
                  />
                </>
              )}
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}
